import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Peoples_Choice.css";
import "swiper/css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import Product_card from "../../common/common_components/product-card/Product_card";
import { useDispatch, useSelector } from "react-redux";
import { GetAllPeoplesChoiceProduct } from "../../../features/admin/products/slice";
import { IDS } from "../../../utils/IDS";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import { encodeId } from "../../../utils/common";

const Peoples_Choice = () => {
  const [topproducts, setTopproducts] = useState([
    {
      id: 1,
      image: "/assets/images/explore/top-products/product1.png",
      name: "Agarbatti (Rose)",
      subname: "(Incense Stick)",
      oldprise: "450.00",
      prise: "200.00",
      link: "/product-details",
    },
    {
      id: 2,
      image: "/assets/images/explore/top-products/product2.png",
      name: "Agarbatti (Rose)",
      subname: "(Incense Stick)",
      oldprise: "450.00",
      prise: "200.00",
      link: "/product-details",
    },
    {
      id: 3,
      image: "/assets/images/explore/top-products/product1.png",
      name: "Agarbatti (Rose)",
      subname: "(Incense Stick)",
      oldprise: "450.00",
      prise: "200.00",
      link: "/product-details",
    },
    {
      id: 4,
      image: "/assets/images/explore/top-products/product1.png",
      name: "Agarbatti (Rose)",
      subname: "(Incense Stick)",
      oldprise: "450.00",
      prise: "200.00",
      link: "/product-details",
    },
  ]);

  // Toggle wishlist state
  const toggleWishlist = (id) => {
    // setTopproducts(prev =>
    //     prev.map(item =>
    //         item.id === id ? { ...item, inWishlist: !item.inWishlist } : item
    //     )
    // );
  };

  const dispatch = useDispatch();
  const products = useSelector(
    (state) => state.commerce.products.choice_products,
  );

  useEffect(() => {
    dispatch(GetAllPeoplesChoiceProduct());
  }, [dispatch]);

  return (
    <section className="Peoples_Choice">
      <div className="container-lg">
        <Common_Title_1
          subText={"People's Choice"}
          linktext={"See all"}
          link={"/all-products"}
        />

        <div className="slider_sec">
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: { slidesPerView: 1.5, spaceBetween: 10 },
              575: { slidesPerView: 3, spaceBetween: 10 },
              768: { slidesPerView: 4, spaceBetween: 10 },
              1200: { slidesPerView: 5, spaceBetween: 10 },
            }}
            className="mySwiper pb-5"
          >
            {products.map((data) => (
              <SwiperSlide key={data.id}>
                <Product_card
                  average_rating={data.average_rating}
                  id={data.id}
                  image={IDS.IMG_URL + data.image}
                  name={data.name}
                  subname={`(${data?.p_category?.name})`}
                  oldprise={data.mrp}
                  prise={data.price}
                  link={`/product-details/${encodeId(data.id)}`}
                  inWishlist={data.inWishlist}
                  onRemove={() => toggleWishlist(data.id)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Peoples_Choice;
